import React from "react";
import { useNavigate } from "react-router-dom";
import { Bot, Play, Settings2 } from "lucide-react";
import { Card, CardContent, StatusBadge, Button } from "@/components/ds";
import { RECEPTIONIST_STATUS } from "./constants";
import type { DashboardData } from "@/lib/api";

export function ReceptionistStatus({ data }: { data: DashboardData["receptionist"] }) {
  const navigate = useNavigate();
  const meta = RECEPTIONIST_STATUS[data.status] ?? RECEPTIONIST_STATUS.draft;
  return (
    <Card data-testid="receptionist-status-card">
      <div className="flex items-center gap-2.5 border-b border-slate-100 px-5 py-4">
        <span className="flex h-7 w-7 items-center justify-center rounded-lg bg-slate-100 text-slate-500">
          <Bot className="h-4 w-4" />
        </span>
        <h3 className="text-sm font-semibold text-slate-900">Receptionist status</h3>
      </div>
      <CardContent className="space-y-4 p-5">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-lg font-semibold text-slate-900" data-testid="receptionist-name">
              {data.name || "Not configured yet"}
            </p>
            <p className="text-xs text-slate-500">Your AI front desk</p>
          </div>
          <StatusBadge tone={meta.tone} data-testid="receptionist-status-badge">{meta.label}</StatusBadge>
        </div>
        <div className="flex gap-2">
          <Button size="sm" variant="outline" className="flex-1" onClick={() => navigate("/app/receptionist")} data-testid="receptionist-test-btn">
            <Play className="h-4 w-4" /> Test
          </Button>
          <Button size="sm" variant="outline" className="flex-1" onClick={() => navigate("/app/receptionist")} data-testid="receptionist-configure-btn">
            <Settings2 className="h-4 w-4" /> Configure
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
